import { BehaviorSubject, Observable } from 'rxjs';
import { HypeModel } from '../models/hype.model';

export abstract class AbstractHypeService {
    protected hypeConfig: HypeModel;
    protected hypeConfigProvider: BehaviorSubject<HypeModel>;

    constructor() {
        this.hypeConfigProvider = new BehaviorSubject<HypeModel>(this.hypeConfig);
    }

    getConfig(): Observable<HypeModel> {
        return this.hypeConfigProvider;
    }
    abstract buttonClicked(): void;
    abstract secondaryButtonClicked(): void;

    showContextTakeover?(naturalLanguagePrompt: string, onClose: (refinedPurpose: string) => void): void;
}
